// Hooks
import { useEffect } from 'react';
/**
 * @description hook to run a function when user hits Escape
 * This is generally used for closing modals or escaping out of a window
 *
 * @param {() => void} onEscapeKey function to run when user hits Esc key
 *
 * @returns {void} hook attached
 */
export var useEscapeKeyboardEvent = function (onEscapeKey) {
    useEffect(function () {
        if (onEscapeKey) {
            var escapeToClose_1 = function (event) {
                if (event.key === 'Escape') {
                    onEscapeKey();
                }
            };
            window.addEventListener('keydown', escapeToClose_1);
            return function () {
                window.removeEventListener('keydown', escapeToClose_1);
            };
        }
        return function () { return null; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
//# sourceMappingURL=useEscapeKeyboardEvent.js.map